export function Share({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" className={`size-4 text-current ${className}`} data-sentry-element="svg" data-sentry-component="Share" data-sentry-source-file="share.tsx">
      <g clipPath="url(#clip0_931_4487)" data-sentry-element="g" data-sentry-source-file="share.tsx">
        <path d="M9.16667 9.36031H7.83333C6.73973 9.35989 5.66682 9.65841 4.73058 10.2236C3.79435 10.7888 3.0304 11.5991 2.52133 12.567C2.50702 12.3873 2.49991 12.2072 2.5 12.027C2.5 8.34498 5.48467 5.36031 9.16667 5.36031V2.02698L15.8333 7.36031L9.16667 12.6936V9.36031Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="share.tsx" />
      </g>
      <defs data-sentry-element="defs" data-sentry-source-file="share.tsx">
        <clipPath id="clip0_931_4487" data-sentry-element="clipPath" data-sentry-source-file="share.tsx">
          <rect width="16" height="16" fill="white" transform="translate(0.5 0.0269775)" data-sentry-element="rect" data-sentry-source-file="share.tsx" />
        </clipPath>
      </defs>
    </svg>;
}